import $ from 'jquery';

$('tbody').on('click', 'tr[data-link]', function updateLocation() {
  window.location = this.dataset.link;
});
